import React from 'react';

const ShipmentStatus = ({EQData, ERDynamic, Open, DateFormat}) => {
    if(ERDynamic.orderDetails.ShippingStatus === null || ERDynamic.orderDetails.ShippingStatus === undefined) return null;
    let deliveredText = (ERDynamic.orderDetails.ShippingStatus.toLowerCase() === "delivered") ? "Delivered" : "Yet to deliver";
    return(
      <div className="relative margin-bottom-medium">
      <p className="margin-bottom-small tiny-padding-vert-tiny medium-padding-vert-small status_title_text">
        You can track the status below:
      </p>
      <div className="panel row padding-horiz-small shippment">
        <h5 className="margin-top-zero margin-bottom-small">{EQData.eqreturndellist[0].title}
            <span className="text-brand-1">{ERDynamic.orderDetails.ShippingStatus}</span>
        </h5>
        <div className="column medium-p-50 padding-vert-zero kit_details">
            <ul className="no-bullet bold text-large spaced-small">
                <li>
                    <span className="text-xlarge space-left">Kit No 1</span>
                    <span className="normal-weight space-left">{"- " + EQData.eqreturndellist[0].trackid +":"}</span>
                    <a data-cs-mask data-track={ERDynamic.orderDetails.TrackingNumber} className="link space-left" href={"https://www.ups.com/WebTracking/track?trackNums="+ ERDynamic.orderDetails.TrackingNumber }>{ERDynamic.orderDetails.TrackingNumber}</a>
                </li>
            </ul>
            <div className="store_location">
                <a onClick={Open} data-track={EQData.eqreturndellist[0].location} className="bold block text-large link">{EQData.eqreturndellist[0].location}</a>
            </div>
        </div>
        <div className={"column medium-p-50 w_track-status m_status-" + ERDynamic.orderDetails.ShippingStatus.toLowerCase()}>
            <ul className="tiny-block-grid-3">
                <li className="padding-all-zero relative active">
                    <div className="VzReturn-kitBox">
                    </div>
                </li>
                <li className="padding-all-zero relative text-center">
                    <div className="vzicon icon-truck">
                    </div>
                </li>
                <li className="padding-all-zero left relative text-right">
                    <div className="vzicon icon-home-alt">
                    </div>
                </li>
            </ul>
            <div className="relative p-80 center track-status_line">
                <ul className="tiny-block-grid-3 p-100">
                    <li className="padding-all-zero">
                        <div align="left">
                            <div className="track-status_point m_point1">
                            </div>
                        </div>
                    </li>
                    <li className="padding-all-zero">
                        <div align="center">
                            <div className="track-status_point m_point2">
                            </div>
                        </div>
                    </li>
                    <li className="padding-all-zero">
                        <div align="right">
                            <div className="track-status_point m_point1">
                            </div>
                        </div>
                    </li>
                </ul>
                <div className="track-status_default">
                    <div className="track-status_state"></div>
                </div>
            </div>
            <ul className="tiny-block-grid-3">
				<li className="padding-all-zero relative active">
					<div className="track-status_text left">					
						Ordered<br/> <strong>{DateFormat(ERDynamic.orderDetails.OrderPlacementDate)}</strong>
					</div>
				</li>
				<li className="padding-all-zero relative text-center">
					<div data-cs-mask className="track-status_text">
					
						Shipped<br/> ({ERDynamic.orderDetails.KitOrdered} kits)<br/> <strong>{DateFormat(ERDynamic.orderDetails.ShippingStatusDate)}</strong>
					</div>
				</li>
				<li className="padding-all-zero left relative text-right">
					<div className="track-status_text right">
						{deliveredText}
					</div>
				</li>
			</ul>
        </div>
      </div>
      </div>
    )
}

export default ShipmentStatus



// WEBPACK FOOTER //
// ./src/components/modules/ShipmentStatus.js